import { useEffect } from "react";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";

export default function Contact() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Contact" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Contact"
        description={`Contactez ${brandConfig.brandName} pour toute demande commerciale ou information produit.`}
      />
      <h1>Contact</h1>
      <div className="card">
        <p className="color-product-desc">
          Pour toute demande commerciale ou information produit :
        </p>
        <p className="color-product-desc">
          Email :{" "}
          <a href="mailto:contact@thetresorsafe.com">
            contact@thetresorsafe.com
          </a>
          <br />
          Tél. : <a href="tel:+33785756439">+33 7 78 575 64 39</a>
        </p>
        <p className="color-product-desc">Horaires : Lun–Ven, 9h–18h (CET)</p>
      </div>
    </>
  );
}
